import InputMask from '@mona-health/react-input-mask';
import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { BeforeMaskedStateChangeStates, InputState } from 'react-input-mask';

type TextFieldProps = MuiTextFieldProps & {
  mask?: string | Array<RegExp>,
  maskPlaceholder?: string,
  alwaysShowMask?: boolean,
  beforeMaskedStateChange?: (states: BeforeMaskedStateChangeStates) => InputState,
};

function TextField({ multiline, ...props }: TextFieldProps){
  return(
    <>
      {!multiline ?
        <InputMask size='small' fullWidth {...props}>
          <MuiTextField/>
        </InputMask >
        :
        <MuiTextField multiline fullWidth size='small' {...props}/>
      }
    </>
  )
} export default TextField;